@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Lokalizacja
    </h3>
    <div class="row">
      <div class="col-md-4">
        <app-label label="Miejscowość:">
          {{ application?.city || '-' }}
        </app-label>
      </div>
      @if (application?.roadNumber; as roadNumber) {
        <div class="col-md-4">
          <app-label label="Numer drogi:">
            {{ roadNumber }}
          </app-label>
        </div>
      }
      @if (application?.roadName; as roadName) {
        <div class="col-md-4">
          <app-label label="Nazwa drogi:">
            {{ roadName }}
          </app-label>
        </div>
      }
      @if (application?.street; as street) {
        <div class="col-md-4">
          <app-label label="Ulica:">
            {{ street }}
          </app-label>
        </div>
      }
      @if (application?.houseNumber; as houseNumber) {
        <div class="col-4">
          <app-label label="Numer budynku:">
            {{ houseNumber }}
          </app-label>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-12">
        <app-label label="Geometria:">
          -
        </app-label>
      </div>
    </div>
    <br>
    <dl class="mb-5">
      <dt class="mb-3">
        <strong>Działki</strong>
      </dt>
      <dd>
        <app-parcels-preview [parcels]="application?.parcels || []"></app-parcels-preview>
      </dd>
    </dl>
    <div class="row">
      <div class="col-12">
        <app-label label="Nazwa obiektu/urządzenia:">
          {{ application?.description || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label
          label="Opis dotyczący określenia technologii prowadzenia robót budowlanych związanych z lokalizacją w pasie drogowym liniowych urządzeń obcych:">
          {{ application?.constructionTechnologyDescription || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
